<template>
  <div class="phonePage07" :style="bgRight">
    <div class="m_right">
      <div class="m_box">
        <div class="m_area">
          <div class="m_area_header" v-html="$tools.localStorageFn.get('PAGE_DATE').banner6_title">
          </div>
          <div class="m_form">
            <el-form ref="ruleForm" :rules="rules" :model="form">
              <el-form-item label="您的姓名" prop="name" :class="nameBlur || form.name ? 'active' : ''">
                <el-input v-model="form.name" @focus="() => {
                  nameBlur = true;
                }
                  " @blur="() => {
    nameBlur = false;
  }
    "></el-input>
              </el-form-item>
              <el-form-item label="公司名称" prop="firm" :class="firmBlur || form.firm ? 'active' : ''">
                <el-input v-model="form.firm" @focus="() => {
                  firmBlur = true;
                }
                  " @blur="() => {
    firmBlur = false;
  }
    "></el-input>
              </el-form-item>
              <el-form-item label="联系方式" prop="phone" :class="phoneBlur || form.phone ? 'active' : ''">
                <el-input v-model="form.phone" @focus="() => {
                  phoneBlur = true;
                }
                  " @blur="() => {
    phoneBlur = false;
  }
    "></el-input>
              </el-form-item>
              <el-form-item label="请填写验证码" prop="code" :class="codeBlur || form.code ? 'active' : ''">
                <el-input v-model="form.code" @focus="() => {
                  codeBlur = true;
                }
                  " @blur="() => {
    codeBlur = false;
  }
    ">
                  <div slot="suffix" @click="waitTime == 0 ? code() : ''" class="code">
                    {{ waitTime == 0 ? "发送验证码" : waitTime + "s" }}
                  </div>
                </el-input>
              </el-form-item>



              <el-form-item label="上传资料" prop="file">
                <form name="form"
                  style="margin-left: 8.0rem;display: flex;justify-content: space-between;align-items: center;transform: translateY(-.3rem);padding-right: 2.0rem;">
                  <!-- <input type="file" @change="inputChange" style="margin-left: 100px;"> -->
                  <input type="file" name="picpath" id="picpath" style="display: none;"
                    onchange="document.form[1].path.value=this.value" @change="inputChange" />
                  <input name="path" value="请上传30M以内文件" readonly
                    style="border: none;background:transparent;width: 100%;color: #909399;">

                  <img src="@/assets/images/icon_upload.png" onclick="document.form[1].picpath.click()" alt=""
                    style="width: 20px;height: 20px;cursor: pointer;">
                  <!-- <input type="button" value="上传文件" onclick="document.form.picpath.click()"
                      style="background: #333333;color: #fff;"> -->
                </form>
              </el-form-item>

              <el-form-item label="案件描述" prop="outline" style="border: 0; margin-bottom: 0; padding-bottom: 0"
                :class="outlineBlur || form.outline ? 'active' : ''">
              </el-form-item>
              <el-form-item prop="outline" style="padding-bottom: 0" :class="outlineBlur || form.outline ? 'active' : ''">
                <el-input v-model="form.outline" @focus="() => {
                  outlineBlur = true;
                }
                  " @blur="() => {
    outlineBlur = false;
  }
    "></el-input>
              </el-form-item>

              <div class="f_btn" @click="submit">
                <div>
                  提交
                  <div class="line"></div>
                </div>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>

    <floatService style="position: absolute;"></floatService>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bgRight: {
        background:
          "url(" +
          this.$tools.localStorageFn.get("PAGE_DATE").banner6_video +
          ") no-repeat center center",
      },
      current: 0,
      form: {},
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        firm: [{ required: true, message: "请输入公司名称", trigger: "blur" }],
        phone: [{ required: true, message: "请输入联系方式", trigger: "blur" }],
      },

      waitTime: 0,


      nameBlur: false,
      firmBlur: false,
      phoneBlur: false,
      codeBlur: false,
      outlineBlur: false,
    };
  },
  methods: {
    // 轮播变化
    onChange(index) {
      this.current = index;
    },
    submit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let formData = new FormData();
          console.log(formData)
          formData.append('name', this.form.name);
          formData.append('firm', this.form.firm);
          formData.append('phone', this.form.phone);
          formData.append('code', this.form.code);
          formData.append('verification_key', this.form.verification_key);
          formData.append('outline', this.form.outline);
          formData.append('file', this.form.file);
          this.$axios
            .post(process.env.VUE_APP_API + "/api/v1/message", formData)
            .then((res) => {
              console.log("留言提交", res);
              if (res.status == 200 || res.status == 201) {
                this.$message.success("提交成功");
                this.form = {};
                document.form[1].path.value = ''
              } else {
                this.$message.error(res.response.data.message99);
              }
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        } else {
          this.$message.error("存在未填信息");
          return false;
        }
      });
    },
    code() {
      let that = this;
      this.$axios
        .post(process.env.VUE_APP_API + "/api/v1/verificationCodes", {
          phone: this.form.phone,
        })
        .then((res) => {
          console.log("验证码", res);
          if (res.status == 200 || res.status == 201) {
            this.form.verification_key = res.data.key;
            this.waitTime = 60;
            let timer = setInterval(function () {
              if (that.waitTime > 0) {
                that.waitTime = that.waitTime - 1;
              } else {
                clearInterval(timer);
              }
            }, 1000);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((error) => {
          this.$message.error(error.response.data.message);
        });
    },


    inputChange(e) {
      console.log(22222, e.target.files[0]);
      if (e.target.files[0].size > 30 * 1024 * 1024) {
        this.$message.warning("文件大小超过30MB");
        e.target.value = "";
      } else {
        this.form.file = e.target.files[0];
        console.log(this.form.file);
      }
    },
  },
};
</script>
<style lang="scss">
.phonePage07 {
  width: 100%;
  height: 100%;
  // background: url(~@/assets/images/homeBg07_right.png) no-repeat center center;
  background-size: cover !important;
  padding-top: 16vh;
  position: relative;

  .m_right {
    display: flex;
    align-items: center;
    justify-content: center;

    .m_box {
      .m_area {
        .m_area_header {
          padding-left: 1.6rem;

          *:first-child {
            font-size: 1.6rem !important;
          }

          *:nth-child(2) {
            font-size: 1.4rem !important;
          }

          h2 {
            font-size: 1.6rem;
            font-family: Microsoft JhengHei UI;
            font-weight: 400;
            color: #013060;
            margin: 0;
            margin-bottom: 1.2rem;
          }

          h3 {
            font-size: 1.4rem;
            font-family: Microsoft JhengHei UI;
            font-weight: 400;
            margin: 0;
            color: #333333;
          }
        }
      }

      .m_form {
        padding: 2.0rem 0 0 1.2rem;

        .code {
          cursor: pointer;
          width: 7.5rem;
          height: 4.0rem;
          line-height: 4.0rem;
          text-align: center;
          background: #333333;
          font-size: 1.2rem;
          font-family: Microsoft YaHei UI;
          font-weight: 400;
          color: #ffffff;
        }

        .el-form {
          .el-form-item {
            position: relative;
            margin-bottom: 0;
            width: 30.0rem;
            border-bottom: .1rem solid #606266;
            margin-bottom: 2.0rem;
            padding-bottom: .4rem;
          }

          .el-input {
            width: calc(100%);
          }

          .el-input__inner {
            height: 4.0rem;
            line-height: 4.0rem;
            padding: 0 1.5rem;
          }

          .el-input__suffix {
            right: 0;
          }

          .el-form-item__error {
            display: none;
          }

          .el-form-item__label {
            position: absolute;
            left: 0;
            font-size: 1.2rem;
            transition: 0.4s;
          }

          .el-input__inner {
            background: transparent;
            border: 0;
          }


          .active {
            border-bottom: .2rem solid #00305f;

            .el-form-item__label {
              transform: scale(0.8) translateY(-2.5rem);
              color: #8d8d8d;
            }
          }
        }

        .f_btn {
          margin: 0 auto;
          width: 10.8rem;
          height: 4.0rem;
          background: #040203;
          text-align: center;
          font-size: 1.2rem;
          color: #ffffff;
          margin-top: 3.2rem;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: 0.5s;
          box-sizing: border-box;

          >div {
            display: inline-block;

            .line {
              width: 0;
              height: .01rem;
              background: #fff;
              transition: 0.5s;
            }
          }
        }

        .f_btn:hover {
          background: #fff;
          border: .01rem solid #040203;
          color: #040203;

          .line {
            width: 100%;
            background: #040203;
          }
        }
      }
    }
  }
}

.active {
  .phonePage07 {
    .m_area_header {
      animation: fade-in-top96 1.7s ease 0s 1 normal none;
    }

    .m_form {
      animation: fade-in-bottom96 1.7s ease 0s 1 normal none;
    }

    .my-swipe {
      transform: translate(0);
      opacity: 1;
    }
  }
}
</style>